import * as React from 'react';
export default (function (props) {
    return React.createElement(
        'div',
        { className: props.className, onClick: props.onClick },
        props.children
    );
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/Table/FilterDropdownMenuWrapper.js
// module id = 334
// module chunks = 0